import React from 'react';
import { Image } from '../../../../wag-react/next-components/image';
import { RecommendedInfo } from './components/RecommendedInfo';
import { TrainingMethodStep } from './components/TrainingMethodStep';
import { CamelizedTrainingMethodStep } from '../../../../types/app/training-guide';
import { Box, BoxProps } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { H3 } from '../../../../wag-react/core-components/h3';
import { theme } from '../../../../wag-react/themes/base-theme';
export type TrainingMethodImageProps = {
  url?: string;
  alt: string;
};
export type TrainingMethodProps = {
  htmlId: string;
  image: TrainingMethodImageProps;
  name: string;
  recommendationRank: string;
  numVotes: number;
  steps: CamelizedTrainingMethodStep[];
} & BoxProps;
export const TrainingMethod = ({
  htmlId,
  image,
  name,
  recommendationRank,
  numVotes,
  steps,
  ...rest
}: TrainingMethodProps) => <Box id={htmlId} {...rest} data-sentry-element="Box" data-sentry-component="TrainingMethod" data-sentry-source-file="index.tsx">
    <Flex alignItems="center" borderRadius={[0, '12px 12px 0 0']} bg={theme.colors.tuftsBlue} justifyContent="space-between" px={['20px']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <H3 color="white" fontFamily="muliBold" fontSize={['mobile-h3', 'tablet-h3', 'desktop-h3']} width={[1, '70%']} data-sentry-element="H3" data-sentry-source-file="index.tsx">
        {`The ${name} Method`}
      </H3>

      {/* Tablet / Desktop only */}
      <RecommendedInfo numVotes={numVotes} recommendationRank={recommendationRank} display={['none', 'flex']} data-sentry-element="RecommendedInfo" data-sentry-source-file="index.tsx" />
    </Flex>

    <Box border={[0, `1px solid ${theme.colors.whisper}`]} borderTop={0} borderRadius="0 0 12px 12px" p={['16px', '24px']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <RecommendedInfo numVotes={numVotes} recommendationRank={recommendationRank} display={['flex', 'none']} mb={['8px', 0]} data-sentry-element="RecommendedInfo" data-sentry-source-file="index.tsx" />

      {image.url && <Image src={`${image.url}?auto=compress&fit=max`} alt={image.alt} borderRadius="4px" height={['141px', '289px']} width={1} mb={['20px', '24px']} />}

      {steps.map(({
      name: stepName,
      description
    }, index) => <TrainingMethodStep key={stepName} description={description} name={stepName} num={index + 1} mb="24px" />)}
    </Box>
  </Box>;